module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "MAIN_PAGE",
    attrs: {
      "id": "d5e1498"
    }
  }, [_c('p', {
    staticClass: "tx1"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("Between two groups of men that want to make inconsistent kinds of worlds I see no remedy except force … It seems to me that every society rests on the death of men."), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("Oliver Wendell Holmes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80c3bfda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/helm.vue
// module id = 78
// module chunks = 0